/** The small mark a toolbar picker carries while a value is applied. The
 *  trigger it sits on must be positioned (`relative`). */
export function ToolbarActiveDot() {
  return (
    <span
      aria-hidden
      className="absolute -right-0.5 -top-0.5 size-1.5 rounded-full bg-primary"
    />
  );
}
